module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/_expose-loader@0.7.5@expose-loader?$!./~/_jquery@3.6.0@jquery/dist/jquery.js-exposed
// module id = 568
// module chunks = 64